export var PriceProviderType;
(function (PriceProviderType) {
    PriceProviderType["STATIC"] = "static";
    PriceProviderType["DYNAMIC"] = "dynamic";
})(PriceProviderType || (PriceProviderType = {}));
